// 路由配置文件（如 router/index.js）
import Home from "../components/home.vue";
import App from "../components/app.vue";
// 可选：引入404组件（需自行创建）
// import NotFound from "../components/NotFound.vue";

const routers = [
  // 根路径直接渲染首页组件
  {
    path: "/",
    name: "root", // 补充name，方便编程式导航
    component: Home,
  },
  // 首页相关路径重定向（避免重复配置）
  {
    path: "/home",
    name: "home",
    redirect: "/", // 访问/home时跳转到根路径
  },
  {
    path: "/yuanyi",
    name: "yuanyi", // 补充name
    redirect: "/", // 访问/yuanyi时跳转到根路径
  },
  // App组件路由
  {
    path: "/app",
    name: "app",
    component: App,
    // 可选：添加嵌套路由（如有子页面需求）
    // children: [
    //   {
    //     path: "detail", // 完整路径：/app/detail
    //     name: "appDetail",
    //     component: () => import("../components/AppDetail.vue") // 懒加载
    //   }
    // ]
  },
  // 404路由（放在最后，匹配所有未定义路径）
  {
    path: "*",
    redirect: "/", // 或指向404组件：component: NotFound
  }
];

export default routers;